import { createAPIMutationHook } from '@medizzy/api';
import { requestOTP } from '../methods/request-otp';

export const useRequestOTP = createAPIMutationHook({
  mutationFn: requestOTP,
});
